/* other amount

   Will show other amount input if amount is == 0
 ========================================================================== */

export default function showOtherAmount() {
  const ecardFormComponent = document.querySelector('*[data-component="ecard-form"]');

  if (ecardFormComponent) {
    const inputs = document.querySelectorAll('.js-can-show-other-amount input[type=radio]');
    const otherAmountDiv = document.querySelector('div#ecard_amount_other');

    inputs.forEach((input) => {
      input.addEventListener('click', (event) => {
        if (event.target.value === '0' && otherAmountDiv.classList.contains('sr-only')) {
          otherAmountDiv.classList.remove('sr-only');
        } else if (!otherAmountDiv.classList.contains('sr-only')) {
          otherAmountDiv.classList.add('sr-only');
        }
      });
    });
  }
}
